/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IMealSchedule } from 'app/shared/model/meal-schedule.model';
import { IRecipe } from 'app/shared/model/recipe.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { INutritionPlan } from 'app/shared/model/nutrition-plan.model';

export interface IMealAdvise {
  id?: string;
  active?: boolean;
  timestampentry?: number;
  lastupdated?: number;
  cursor?: number;
  microSec?: number;
  mealDetailsSchedule?: IMealSchedule;
  recipeMealDetails?: IRecipe;
  advisedBy?: IDoctor;
  nutritionPlan?: INutritionPlan | null;
}

export const defaultValue: Readonly<IMealAdvise> = {
  active: false,
};
